import axios from 'axios';
import { loginreq, req, reqJson } from './axiosFun';

// 闁谎嗩嚙缂嶅秹骞掗妷銉ョ稉 
export const login = (params) => { return loginreq("post", "/app-yijiu-backstage/login", params) };
// 闁兼儳鍢茶ぐ鍥偨閵婏箑鐓曢柤鎸庣矊瀹?
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出登录
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };




// user manage
export const setPrincipalValidity = (params) => { return reqJson("post", "/app-yijiu-backstage/setPrincipalValidity", params) };
export const getUserList = (params) => { return req("post", "/app-yijiu-backstage/getUserList", params) };
export const setUserInfo = (params) => { return req("post", "/app-yijiu-backstage/setUserInfo", params) };
export const setIsDelete = (params) => { return req("post", "/app-yijiu-backstage/setIsDelete", params) };
export const getPrincipalOptions = (params) => { return req("post", "/app-yijiu-backstage/getPrincipalOptions", params) };
export const getPrincipalVipUsers = (params) => { return req("post", "/app-yijiu-backstage/getPrincipalVipUsers", params) };
export const batchSetVipExpireTime = (params) => { return reqJson("post", "/app-yijiu-backstage/batchSetVipExpireTime", params) };
export const batchSetVip2ExpireTime = (params) => { return reqJson("post", "/app-yijiu-backstage/batchSetVip2ExpireTime", params) };
export const checkCampusFranchise = (params) => { return req("post", "/app-yijiu-backstage/checkCampusFranchise", params) };

export const getUserList2 = (params) => { return req("post", "/app-yijiu-backstage/getUserList2", params) };
export const setUserInfo2 = (params) => { return req("post", "/app-yijiu-backstage/setUserInfo2", params) };
export const copyCertificationToComic = (params) => { return req("post", "/app-yijiu-backstage/copyCertificationToComic", params) };



//闁告帒妫涚悮顐ょ不閿涘嫭鍊?
export const addCourseClassify = (params) => { return req("post", "/app-yijiu-backstage/addCourseClassify", params) };
export const upCourseClassify = (params) => { return req("post", "/app-yijiu-backstage/upCourseClassify", params) };
export const moveCourseClassify = (params) => { return req("post", "/app-yijiu-backstage/moveCourseClassify", params) };
export const upCourseClassifySort = (params) => { return req("post", "/app-yijiu-backstage/upCourseClassifySort", params) };
export const deleteCourseClassify = (params) => { return req("post", "/app-yijiu-backstage/deleteCourseClassify", params) };
export const getCourseClassifyList = (params) => { return req("post", "/app-yijiu-backstage/getCourseClassifyList", params) };


//閻犙冨閺嬶紕绮婚敍鍕€?
export const addCourseData = (params) => { return req("post", "/app-yijiu-backstage/addCourseData", params) };
export const deleteCourseData = (params) => { return req("post", "/app-yijiu-backstage/deleteCourseData", params) };
export const getCourseClassifyDataList = (params) => { return req("post", "/app-yijiu-backstage/getCourseClassifyDataList", params) };
export const getCourseDataList = (params) => { return req("post", "/app-yijiu-backstage/getCourseDataList", params) };
export const upCourseData = (params) => { return req("post", "/app-yijiu-backstage/upCourseData", params) };
export const moveCourseData = (params) => { return req("post", "/app-yijiu-backstage/moveCourseData", params) };
export const upCourseDataSort = (params) => { return req("post", "/app-yijiu-backstage/upCourseDataSort", params) };

export const getSignatureVue = (params) => { return req("post", "/app-yijiu-backstage/getSignature", params) };





// 轮播图管理
export const selectSlideshow = (params) => { return req("post", "/app-yijiu-backstage/getCarouselList", params) };
export const addSlideshow = (params) => { return req("post", "/app-yijiu-backstage/addCarousel", params) };
export const upSlideshow = (params) => { return req("post", "/app-yijiu-backstage/upCarousel", params) };
export const deleteSlideshow = (params) => { return req("post", "/app-yijiu-backstage/deleteCarousel", params) };
export const getTvUpdateConfigList = (params) => { return req("post", "/app-yijiu-backstage/getTvUpdateConfigList", params) };
export const addTvUpdateConfig = (params) => { return req("post", "/app-yijiu-backstage/addTvUpdateConfig", params) };
export const upTvUpdateConfig = (params) => { return req("post", "/app-yijiu-backstage/upTvUpdateConfig", params) };
export const deleteTvUpdateConfig = (params) => { return req("post", "/app-yijiu-backstage/deleteTvUpdateConfig", params) };


//闁哥喎妫楅幖褏绮婚敍鍕€?
export const getCommodityStatus = (params) => { return req("post", "/app-yytc-backstage/getCommodityStatus", params) };
export const addCommodity = (params) => { return req("post", "/app-yytc-backstage/addCommodity", params) };
export const deleteCommodity = (params) => { return req("post", "/app-yytc-backstage/deleteCommodity", params) };

    
 /**
 * 妤犵偛鍟胯ぐ鎾础韫囨凹鍞撮柛鎰噹椤?
 **/
 export const upPlatformContent = (params) => { return req("post", "/app-yytc-backstage/upPlatformContent", params) };
 export const getPlatformContentList = (params) => { return req("post", "/app-yytc-backstage/getPlatformContentList", params) };

 

/**
 * 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?缂佺媴绱曢幃濠囧川? **/
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥偨閵婏箑鐓曢柛鎺擃殙閵?
export const addAdmin = (params) => { return req("post", "/app-yijiu-backstage/addAdmin", params) };
export const upAdmin = (params) => { return req("post", "/app-yijiu-backstage/upAdmin", params) };
export const deleteAdmin = (params) => { return req("post", "/app-yijiu-backstage/deleteAdmin", params) };
export const getAdminList = (params) => { return req("post", "/app-yijiu-backstage/getAdminList", params) };







  
//閻犲洤澧介埢鑲╃不閿涘嫭鍊?
export const addCourse = (params) => { return req("post", "/app-yijiu-backstage/addCourse", params) };
export const upCourse = (params) => { return req("post", "/app-yijiu-backstage/upCourse", params) };
export const deleteCourse = (params) => { return req("post", "/app-yijiu-backstage/deleteCourse", params) };
export const getCourseList = (params) => { return req("post", "/app-yijiu-backstage/getCourseList", params) };






  
//闁哄倸娲ㄩ悵椋庣不閿涘嫭鍊?
export const addArticle = (params) => { return req("post", "/app-yijiu-backstage/addArticle", params) };
export const upArticle = (params) => { return req("post", "/app-yijiu-backstage/upArticle", params) };
export const deleteArticle = (params) => { return req("post", "/app-yijiu-backstage/deleteArticle", params) };
export const getArticleList = (params) => { return req("post", "/app-yijiu-backstage/getArticleList", params) };






  
//闁奸绀佺粭鈧紒鐙呯磿閹?
export const addTeacherData = (params) => { return req("post", "/app-yijiu-backstage/addTeacherData", params) };
export const upTeacherData = (params) => { return req("post", "/app-yijiu-backstage/upTeacherData", params) };
export const deleteTeacherData = (params) => { return req("post", "/app-yijiu-backstage/deleteTeacherData", params) };
export const getTeacherDataList = (params) => { return req("post", "/app-yijiu-backstage/getTeacherDataList", params) };

export const addTeacher = (params) => { return req("post", "/app-yijiu-backstage/addTeacher", params) };
export const upTeacher = (params) => { return req("post", "/app-yijiu-backstage/upTeacher", params) };
export const deleteTeacher = (params) => { return req("post", "/app-yijiu-backstage/deleteTeacher", params) };
export const getTeacherList = (params) => { return req("post", "/app-yijiu-backstage/getTeacherList", params) };




export const addCourseIntroduce = (params) => { return req("post", "/app-yijiu-backstage/addCourseIntroduce", params) };
export const upCourseIntroduce = (params) => { return req("post", "/app-yijiu-backstage/upCourseIntroduce", params) };
export const deleteCourseIntroduce = (params) => { return req("post", "/app-yijiu-backstage/deleteCourseIntroduce", params) };
export const getCourseIntroduceList = (params) => { return req("post", "/app-yijiu-backstage/getCourseIntroduceList", params) };
export const getCourseIntroduceShowConfig = (params) => { return req("post", "/app-yijiu-backstage/getCourseIntroduceShowConfig", params) };
export const upCourseIntroduceShowConfig = (params) => { return req("post", "/app-yijiu-backstage/upCourseIntroduceShowConfig", params) };






/**
 * 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?
 **/
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥偨閵婏箑鐓曢柛鎺擃殙閵?
export const userList = (params) => { return req("post", "/api/User/list", params) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?濞ｅ洦绻傞悺銊╂晬閸喎娼戦柛鏃傚Х缁鳖亝娼忛幋顖滅
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁告帞濞€濞呭酣鎮介妸锕€鐓?
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闂佹彃绉堕悿鍡欌偓闈涙閻?
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 锁定或解锁用户
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁轰胶澧楀畵渚€寮堕崘顔筋€?
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁轰胶澧楀畵渚€寮堕崘顔筋€欏ǎ鍥ㄧ箓閻?
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥焾閵娾晜锛岄悹浣稿⒔閻?
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?濞ｅ洦绻傞悺銊╂焾閵娾晜锛岄悹浣稿⒔閻?
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁活潿鍔嶉崺娑欑▔鐎ｎ剙娈?
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 闁活潿鍔嶉崺娑氱不閿涘嫭鍊?闁告帡鏀遍弻濠勭磽閹惧磭鎽?
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?
 **/
// 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥嚕濠婂啫绀婱odule/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?闁哄秷顫夊畵渚€鎳ｅ鍐ㄧ闁兼儳鍢茶ぐ鍥极閻楀牆绁?
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥偉閸撲線鐛撻柤鎸庣矊瀹曠兂odule/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?濞ｅ浂鍠楅弫濂告嚕濠婂啫绀?
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 闁兼寧绮屽畷鐔虹不閿涘嫭鍊?闁告帞濞€濞呭酣鎳ｅ鍐ㄧ
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?
 **/
// 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥╂喆閹烘洖顥忛柛鎺擃殙閵?
export const roleList = (params) => { return req("post", "/api/Role/list", params) };
// 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?濞ｅ洦绻傞悺銊╂晬閸喎娼戦柛鏃傚Х缁鳖亝娼忛幋顖滅
export const roleSave = (params) => { return req("post", "/api/Role/save", params) };
// 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?闁告帞濞€濞呭海鎲撮幒鏇烆棌
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?闁兼寧绮屽畷鐔煎级閸愵喗顎欓柨娑樼墣楠炲繘宕ｉ弽鐢电
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 閻熸瑦甯熸竟濠勭不閿涘嫭鍊?闁兼寧绮屽畷鐔煎级閸愵喗顎欓柨娑樼墔缁绘氨鈧稒锕槐?
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 闁稿浚鍓欏鍐不閿涘嫭鍊?
 **/
// 闁稿浚鍓欏鍐不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥礂椤掆偓瀵板啴宕氬Δ鍕┾偓?
export const deptList = (params) => { return req("post", "/api/Dept/list", params) };
// 闁稿浚鍓欏鍐不閿涘嫭鍊?濞ｅ洦绻傞悺銊╂晬閸喎娼戦柛鏃傚Х缁鳖亝娼忛幋顖滅
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 闁稿浚鍓欏鍐不閿涘嫭鍊?闁告帞濞€濞呭酣宕楅鈧?
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 缂侇垵宕电划娲偝椤栨凹鏆旈柛娆愶耿閸?
 **/
// 缂侇垵宕电划娲偝椤栨凹鏆旈柛娆愶耿閸?闁兼儳鍢茶ぐ鍥╁寲閼姐倗鍩犻柣婊庡灠椤ｃ劑宕ｅ鈧崳娲礆濡ゅ嫨鈧?
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 缂侇垵宕电划娲偝椤栨凹鏆旈柛娆愶耿閸?濞ｅ洦绻傞悺銊╂晬閸喎娼戦柛鏃傚Х缁鳖亝娼忛幋顖滅
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 缂侇垵宕电划娲偝椤栨凹鏆旈柛娆愶耿閸?闁告帞濞€濞呭海鍖栭懡銈囧煚闁绘粠鍨伴。銊╁矗濮椻偓閸?
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 闁哄鍟村铏圭不閿涘嫭鍊?
 **/
// 闁哄鍟村铏圭不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥级閸愵喗顎欓柛鎺擃殙閵?
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 闁哄鍟村铏圭不閿涘嫭鍊?濞ｅ洦绻傞悺銊╁级閸愵喗顎?
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 闁哄鍟村铏圭不閿涘嫭鍊?闁告帞濞€濞呭酣寮堕崘顔筋€?
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 闁哄鍟村铏圭不閿涘嫭鍊?闁兼儳鍢茶ぐ鍥级閸愵喗顎?
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 闁哄鍟村铏圭不閿涘嫭鍊?闂佹澘绉堕悿鍡涘级閸愵喗顎?
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js